import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Image } from "react-bootstrap";
import BidUpload from "./BidUpload";
import Header from "../components/Header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../store";
import { useLocation, useNavigate } from "react-router-dom";
import { api_url } from '../api/config/config';
import ProjectTitle from "../components/ProjectTitle";
import BidProgressBar from "../components/BidProgressBar";
import DetailFacility from "../components/DetailFacility";
import DetailBill from "../components/DetailBill";
import BidCondition from '../pages/BidCondition';
import { Bid, Facility, Opportunity, BidFormInput } from "../types/type";
import { Spinner } from "react-bootstrap";
import Footer from "../components/Footer";
import {
    FormProvider,
    useForm,
    useFormContext,
} from "react-hook-form";
import { setFacilitiesId } from '../store/user/selectfacilitySlice';
import { resetFacilitiesId } from '../store/user/selectfacilitySlice';
import { useApi } from '../api/contexts/ApiContext';
const BidProgress: React.FC = () => {
    const [isOpenMap, setIsOpenMap] = useState<Record<number, boolean>>({});

    const backendURL = api_url;
    const [opportunity, setOpportunity] = useState<Opportunity>();
    const [alreadyBid, setAlreadyBid] = useState<boolean | string>(false);
    const [facilities, setFacilities] = useState<Facility[]>([]);
    const [bidMode, setBidMode] = useState('all');
    const [confirm, setConfirm] = useState(true);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch<AppDispatch>();
    const [bid, setBid] = useState<any>();
    const [winner, setWinner] = useState(1);
    const [recs, setRecs] = useState<{ [key: string]: Facility[] }>({});
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    const navigate = useNavigate();
    const [filteredFacilities, setFilteredFacilities] = useState<Facility[]>([]);
    const queryParams = new URLSearchParams(location.search);
    const opportunityId: number = parseInt(queryParams.get('opportunity_id') || '0', 10);
    const [isEnded, setIsEnded] = useState<boolean>(false);
    const { getModule } = useApi();

    const toggleOpen = (id: number) => {
        setIsOpenMap(prev => ({
            ...prev,
            [id]: !prev[id],
        }));
    };


    const fetchFacilityByOpportunityId = useCallback(async () => {
        try {
            const response = await fetch(`${backendURL}/getFacilityByOpportunityId?opportunity_id=${opportunityId}&user_id=${userInfo?.id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch: ${response.statusText}`);
            }
            const h: any = await response.json();
            setFacilities(h.data);
        } catch (error) {
            console.error('Error: ', error);
        }
    }, [opportunityId]);

    const fetchOpportunity = useCallback(async () => {
        try {
            const response = await fetch(`${backendURL}/getOpportunity?vendor_id=${vendorInfo?.vendor_id}&opportunity_id=${opportunityId}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            const opportunity = (await response.json()).data;
            const end = new Date(opportunity.due * 1000) < new Date();
            setIsEnded(end);
            setOpportunity(opportunity);
            setBidMode(opportunity.mode);
        } catch (error) {
            console.error('Error: ', error);
        }
    }, [opportunityId, userInfo?.id]);

    const hasAlreadyBid = useCallback(async () => {
        try {
            if (userInfo?.id && opportunityId) {
                const body = {
                    user_id: userInfo.id,
                    opportunity_id: opportunityId,
                    vendor_id: vendorInfo?.vendor_id
                }
                const bidApi = await getModule('BidApi');
                const response = await bidApi.hasAlreadyBid(body);
                const bid_id = response.data;
                if (bid_id === false) {
                    navigate(`/mypage`);
                }

                setAlreadyBid(bid_id as boolean | string);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }, [opportunityId, userInfo?.id, navigate]);

    const getBidById = useCallback(async () => {
        if (!userInfo?.id || !opportunityId || !alreadyBid) {
            console.warn('Missing required parameters to fetch bid by ID');
            return;
        }

        try {
            const url = new URL(`${backendURL}/getBidById?bid_id=${alreadyBid}`);
            const response = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch bid: ${response.statusText}`);
            }

            const bidData = await response.json();
            if (!bidData.data) {
                console.warn('No bid data found');
                return;
            }

            const bid = bidData.data;
            setBid(bid);


        } catch (error) {
            console.error('Error fetching bid by ID:', error);
        }
    }, [alreadyBid, opportunityId, userInfo?.id]);


    useEffect(() => {
        setLoading(true);
        Promise.all([fetchFacilityByOpportunityId(), getBidById(), hasAlreadyBid(), fetchOpportunity()]).then(() => {
            setLoading(false);
        });
    }, [fetchFacilityByOpportunityId, getBidById, hasAlreadyBid, fetchOpportunity]);

    useEffect(() => {

        if (bid && facilities.length > 0) {
            const conditionFacilityId = bid?.conditions.map((condition: any) => condition.facility_id);
            const filteredFacilities = facilities.filter((facility: Facility) => conditionFacilityId.includes(facility.id));


            setFilteredFacilities(filteredFacilities);

            const tmp_recs: { [key: string]: Facility[] } = {};
            filteredFacilities.forEach((rec: Facility) => {
                const supplierName = rec.supplier?.name;
                if (supplierName) {
                    if (!tmp_recs[supplierName]) {
                        tmp_recs[supplierName] = [];
                    }
                    tmp_recs[supplierName].push(rec);
                }
            });
            setRecs(tmp_recs);


            const newConditions = bid.conditions.reduce((acc: Record<string, any>, condition: any) => {
                if (condition.facility_id) {
                    acc[condition.facility_id] = condition;
                } else {
                    console.warn('Condition missing facility_id:', condition);
                }
                return acc;
            }, {});
            setValue('conditions', newConditions);
        }
    }, [bid, facilities]);

    // useEffect(() => {
    //     fetchFacilityByOpportunityId();
    // }, [bid, fetchFacilityByOpportunityId]);

    // useEffect(() => {
    //     getBidById();
    // }, [alreadyBid, getBidById]);

    // useEffect(() => {
    //     hasAlreadyBid();
    // }, [opportunity, hasAlreadyBid]);

    // useEffect(() => {
    //     fetchOpportunity();
    // }, [fetchOpportunity]);


    const methods = useForm<BidFormInput>({
        defaultValues: {
            opportunity_id: opportunityId,
            bid_mode: bidMode,
            status: '1',
            conditions: [],
            user_id: userInfo?.id,
        },
    });

    const { handleSubmit, setValue, watch } = methods;

    const handleBid = () => {
        dispatch(resetFacilitiesId());
        dispatch(setFacilitiesId(filteredFacilities.map((facility) => facility.id)));
        if (facilities.length == 1) {
            navigate(`/bid?opportunity_id=${opportunityId}`);
        } else if (facilities.length > 1) {
            navigate(`/bid_start?opportunity_id=${opportunityId}`);
        } else {

        }

    };

    const handleBack = () => {
        navigate(`/project_detail?opportunity_id=${opportunityId}`);
    };

    const bidStatus = () => {
        if (opportunity) {
            const due = new Date(opportunity.due * 1000);
            const now = new Date();
            const status = opportunity.status;

            if (due.getTime() < now.getTime()) {
                return (
                    <div className="mb-xl-5 bg-ass-deep-demo-02 text-md text-white text-center fw-400 py-7">
                        応札期間が終了しました
                    </div>
                );
            } else if (winner === userInfo?.id) {
                return (
                    <div className="mb-xl-5 bg-ass-deep-demo-02 text-md text-white text-center fw-400 py-7">
                        他の企業が落札しました
                    </div>
                );
            } else if (status === 0 || status === 1 || status === 2) {
                return (
                    <div className="mb-xl-4 bg-yellow-03 text-md text-white text-center fw-400 py-7">
                        応札中
                    </div>
                );
            } else if (status === 3) {
                return (
                    <div className="mb-xl-4 bg-blue-05 text-md text-white text-center fw-400 py-7">
                        落札済
                    </div>
                );
            }
        }

        return null;
    };

    return (
        <>

            <section className="section-name project-details-section">
                {loading ? <div className="d-flex justify-content-center align-items-center mb-5" style={{ height: '100%' }}>
                    <Spinner animation="border" variant="primary" />
                </div> : <div className="container">
                    {bidStatus()}
                    {opportunity && <ProjectTitle company={opportunity} />}
                    {opportunity && opportunity.status > 0 && <BidProgressBar status={opportunity.status} isFileUploaded={bid?.files?.length > 0} />}

                    <FormProvider {...methods}>
                        <form id="bid-form" method="post">
                            {Object.keys(recs).length > 0 && bid && Object.entries(recs).map(([supplierName, facilities]) => (
                                <div className="bg-ass-demo p-4 mb-5" key={supplierName}>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-7 col-10 mx-auto py-3 mb-3">
                                            <div className="bg-white text-center rounded-pill text-sm py-1 fw-300">
                                                <img className="img img-fluid height-25 mb-1 mr-2" src="assets/images/other/icon-poles.svg" alt="" />
                                                {supplierName}管轄
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {bidMode === 'each' ? (
                                            opportunity && facilities.map((facility, index) => (
                                                <div className="my-1 pt-1 bg-white" key={facility.id}>
                                                    <DetailFacility facility={facility} company={opportunity} isOpen={!isOpenMap[facility.id]}
                                                        onToggle={() => toggleOpen(facility.id)} />
                                                    {!isOpenMap[facility.id] && (
                                                        <div className="bg-white pb-3">
                                                            <DetailBill facility={facility} opportunity={opportunity} isOpen={!isOpenMap[facility.id]} />
                                                        </div>
                                                    )}
                                                    <div className="bg-white pb-3">
                                                        <BidCondition facility={facility} confirm={confirm} />

                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="my-1 pt-1 bg-white">
                                                {opportunity && facilities.map((facility) => (
                                                    <div key={facility.id}>
                                                        <DetailFacility facility={facility} company={opportunity} isOpen={!isOpenMap[facility.id]}
                                                            onToggle={() => toggleOpen(facility.id)} />
                                                        <div className="bg-white pb-3">
                                                            <DetailBill facility={facility} opportunity={opportunity} isOpen={!isOpenMap[facility.id]} />
                                                        </div>
                                                    </div>
                                                ))}

                                                <BidCondition facility={facilities[facilities.length - 1]} confirm={confirm} />

                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}

                            <BidUpload opportunity_id={opportunityId} bid_mode={bidMode} confirm={confirm} is_end={isEnded} />
                        </form>
                    </FormProvider>
                </div>
                }
                <div className="text-center mb-lg-4 mb-4">
                    {isEnded == false &&
                        <button type="button" className="btn btn-lg btn-theme btn-danger rounded-pill px-lg-5 px-3 mr-2" onClick={handleBid}> <span className="mx-3">応札条件を変更する</span> </button>
                    }
                    <button type="button" className="btn btn-lg btn-theme btn-secondary rounded-pill px-lg-5 px-3" onClick={handleBack}><span className="mx-3">戻る</span></button>
                </div>
            </section>
            <Footer />

        </>
    );
}

export default BidProgress;